import React, {useEffect, useRef, useState} from "react";
import { Table, message, Col, Row, Tabs, Button, Input, Popconfirm, Modal, ConfigProvider, Pagination } from 'antd';

import { sendHttpPostRequest } from "../../api/http-request";
import {useHistory} from "react-router-dom";
import Cookies from 'js-cookie';

import memberBg1 from '../../static/image/college-oam/memberBg1.png';


import collegeManageStyles from "./college-oam.module.less";
import idataCourseTableStyles from "../common/global-styles/idatacoding.module.less";


import {BankOutlined} from '@ant-design/icons';
import zhCN from 'antd/lib/locale/zh_CN'

const { Search } = Input;



export interface Props {
  
}
const CollegeClassRoomList: React.FC<Props> = (props) => {
          const [classroomResult, setClassroomResult] = useState([] as any[]);  // 当前显示的结果页
          const [resultSum, setResultSum] = useState(0);  // 搜索返回的结果数
          const [totalCount, setTotalCount] = useState(0);  // 搜索返回的结果数
      
          const queryChannel = useRef(0);  // 来源渠道
          const queryContent = useRef('');  // 记录搜索串
          const order = useRef('');  // 排序升序降序
          const order_by = useRef('');  // 排序列
          const page = useRef(1);  // 记录当前的页数
          const pageSize = useRef(10);  // 记录当前每页展示数量
      
          const channelFilters = useRef([]);  // 渠道过滤项
          const userIsLogin = useRef(false);  // 用户是否登录
          const currentClassRoomId = useRef(null as any);//当前点击的教室ID
            const history = useHistory()

      
          useEffect(() => {
              queryClassRoomList();
          }, [])
      
          /**
           * 查询教室列表
           */
          const queryClassRoomList = () => {
              sendHttpPostRequest(
                  'classroom/api/manager_query_classroom_list',
                  {
                      sessionid: Cookies.get("sessionid"), 
                      page: page.current,
                      pagesize: pageSize.current,
                      query: queryContent.current
                  },
                  queryClassroomListCallback
              )
          }
      
          /**
           * 查询班级列表回调
           * @param response
           */
          const queryClassroomListCallback = (response: any) => {
              // console.log(response)
              message.destroy();
              if (response.code == -100) {
                  // 未登录
                  window.location.href = '/login?next=college-oam';
              } else if (response.is_ok == true) {
                  // 成功
                  setClassroomResult(response.query_list);
                  //console.log(response)
                  setResultSum(response.total_sum);
                  setTotalCount(response.total_count);
                  //setSysCount(response.sys_count);
                  //setUserCount(response.user_count);
                  //setOnlineCount(response.online_count);
              }// else if (response.code == -501) {
                  // 权限不足
                  //window.location.href = '/oam_login?next=oam_chapter';
              //} else {
                  //message.error(response.message);
              //}
          }
      
      
          //页码和页数发生了变化
          const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
              page.current = newPage ? newPage : 1;
              if (newPageSize) {
                  pageSize.current = newPageSize;
              }
              queryClassRoomList();
             
          }
      
         
          /**
           * 删除教室
           */
           const deleteClassRoom = (classroomId: string | number) => {
              sendHttpPostRequest(
                  'classroom/api/manager_delete_classroom',
                  {
                      sessionid: Cookies.get("sessionid"),
                      classroom_id: classroomId,
                  },
                  (response: any) => {
                      // console.log(response)
                      message.destroy();
                      if (response.code == -100) {
                          // 未登录
                          //window.location.href = '/oam_login?next=oam_classroom';
                      } else if (response.is_ok == true) {
                          // 成功
                          message.success("删除成功");
                          const newResultClassRoom = [...classroomResult]
                          setClassroomResult(newResultClassRoom.filter(item=> item.id !== classroomId))
                          
                      } /*else if (response.code == -501) {
                          // 权限不足
                          window.location.href = '/oam_login?next=oam_chapter';
                      } */else {
                          message.error(response.message);
                      }
                  }
              )
          }
      
      
        // 点击 删除
        const onDeleteBtnClick = (name:string, id:number) => {
          deleteClassRoom(id)
        }
      
      
       
      
      
      
          // 渲染操作
          const renderActions = (text:any, record:any) => {
              return <>
              <Row justify="center" align="middle" gutter={[8, 5]} >
             <Col style={{width:80}}><Button type="primary"  className={collegeManageStyles.actionBtn}  value={record.id} onClick={()=>{currentClassRoomId.current = record.id;history.push(`/college-oam/classroom_detail/${currentClassRoomId.current}`)}} > 查 看 </Button></Col>
               {/*<Col style={{width:50}}><Button style={{borderRadius:20,fontSize:12}} size='small' id="edit" value={record.id} type="dashed" onClick={onEditBtnClick}> 编 辑 </Button> </Col> */}
                 
                  { <Col style={{width:80}}>
                  <Popconfirm placement="top" title={'确认删除教室"' + record.name + '"吗？'} onConfirm={onDeleteBtnClick.bind(this, record.name,record.id)} okText="确认" cancelText="取消">
                  <Button type="primary" className={collegeManageStyles.dangerBtn}  id="delete" danger value={record.id} > 删 除 </Button> 
                  </Popconfirm></Col> }
              </Row>
      
              </>
      
              }
      
       
        
          //点击了搜索按钮
          const onSearchBtn = (value: string) => {
              page.current = 1;
              queryContent.current = value;
              queryClassRoomList();
          }
      
          // 表格发生变化
          const onTableChange:any = (pagination:any, filters:any, sorter:any, extra: { currentDataSource: [], action: any })=> {
              if (sorter.order) { //如果选择了排序列
                  //order.current = sorter.order;
                  //order_by.current = sorter.field;
              }
              if (filters.sex) { //如果选择了过滤列
                  //sexFilters.current = filters.sex;
              } else {
                  //sexFilters.current = [];
              }
              
              //page.current = 1;
              //queryUserInfo();
          }
      
          // 表格列
          const cols: any = [
              {
                  title: "序号",
                  dataIndex: "id",
                  key: "id",
                  width: 60,
                  ellipsis: true,
                  align: 'center',
                  render:(text, record, index)=>((page.current - 1)*pageSize.current + classroomResult.indexOf(record) + 1)
              },
              {
                  title: "名称",
                  dataIndex: "name",
                  key: "name",
                  width: 100,
                  ellipsis: true,
                  align: 'left',
                  render:(text, record)=>{
                      return <div style={{cursor:"pointer"}}  onClick={()=>{currentClassRoomId.current = record.id;history.push("/college-oam/classroom_detail")}}>{text}</div>
                  }
              },
              {
                  title: "教师",
                  dataIndex: "real_name",
                  key: "real_name",
                  width: 100,
                  align: 'left',
                  ellipsis: true,
                  render:(text, record)=>(text == ""? record.user_name : text)
              },
              {
                  title: "项目",
                  dataIndex: "course_name",
                  key: "course_name",
                  width: 100,
                  align: 'left',
                  ellipsis: true,
              },
              /*{
                  title: "院校",
                  dataIndex: "college_name",
                  key: "college_name",
                  width: 100,
                  align: 'left',
              },*/
              {
                  title: "学生数",
                  dataIndex: "user_count",
                  key: "user_count",
                  width: 60,
                  align: 'center',
                  ellipsis: true,
              },
              {
                  title: "创建时间",
                  dataIndex: "create_time",
                  key: "create_time",
                  width: 120,
                  align: 'left',
                  ellipsis: true,
              },
              {
                  title: "操作",
                  dataIndex: "actions",
                  key: "actions",
                  width: 180,
                  ellipsis: false,
                  align: 'center',
                  render: renderActions,
              },
          ]
      
          return (
                      <div className={collegeManageStyles.pageWrapper}>
      
                          <Row gutter={[20,20]} className={collegeManageStyles.memberList}>             
                              <Col xs={24} sm={8} style={{backgroundImage:`url(${memberBg1})`,backgroundSize:'100% 100%'}}>
                              <div>
                                  <BankOutlined style={{marginRight:3}} className={collegeManageStyles.icon}/>
                                  班级总数</div>
                              <div className={collegeManageStyles.statNumber}>{totalCount}</div> 
                              </Col>
                              
                          </Row>
                          
                          
                            
                              <div className={collegeManageStyles.memberTableWrapper}>
                                  <Row align="middle" gutter={[16,12]} style={{marginBottom:20}} >
                               
                                  <Col xs={24} md={12} lg={8}>
                                      <Search
                                          placeholder="搜索班级"
                                          style={{ width: '100%', maxWidth: 350 }}
                                          enterButton={true}
                                          onSearch={onSearchBtn}
                                      />
      
                                  </Col>
                              
                                  {/*<Col flex='auto' style={{textAlign:'right'}}> <Button style={{borderRadius:20}} type={'primary'} onClick={onCreateBtnClick}>+新建</Button></Col> */}
                                  </Row>
                                  <div className={idataCourseTableStyles.tableWrapper}>
                                  <ConfigProvider locale={zhCN}>
                                      <Table
                                          dataSource={classroomResult}
                                          columns={cols}
                                          rowKey={record => record.id}
                                          pagination={false}
                                      // bordered={true}
                                          onChange={onTableChange}
                                      />
                                  </ConfigProvider>
                                  </div>
      
                                  <ConfigProvider locale={zhCN}>
                                      <div className={collegeManageStyles.paginationWrap}>
                                          <Pagination
                                              defaultCurrent={1}
                                              total={resultSum}
                                              current={page.current}
                                              defaultPageSize={pageSize.current}
                                              hideOnSinglePage={true}
                                              onChange={onPageChange}
                                              showQuickJumper={true}
                                              showTotal={total => `共 ${total} 班级`}
                                              pageSizeOptions={["3","20","30","50","100"]}
                                          />
                                      </div>
                                  </ConfigProvider>
                              </div>
                          </div>
            
      
          )
      
}


export default CollegeClassRoomList